// extracted by mini-css-extract-plugin
export default {"ArrowButton":"ArrowButton_ArrowButton__f-gRM","mainHeader":"ArrowButton_mainHeader__fhp9F"};